import React, { useEffect, useRef } from 'react';
import ErrorFallback from './error-fallback';
const ControllerError = ({ children, wfConfig, onError, }) => {
    const reportedError = useRef();
    const { controllerError } = wfConfig;
    useEffect(() => {
        var _a;
        if (controllerError &&
            ((_a = reportedError.current) === null || _a === void 0 ? void 0 : _a.message) !== controllerError.message) {
            reportedError.current = Object.assign({}, controllerError);
            onError === null || onError === void 0 ? void 0 : onError(new Error(controllerError.message));
        }
    }, [controllerError, onError]);
    if (controllerError) {
        return (React.createElement(ErrorFallback, { errorMessage: controllerError.message, errorId: controllerError.id }));
    }
    return children;
};
export default ControllerError;
//# sourceMappingURL=controller-error.js.map